import { AlertCircle, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/**
 * Shared error state for sidebar panels.
 * Uses `text-destructive` (full opacity, theme-aware) for the icon and
 * `text-muted-foreground` for message text - accessible on both light and dark backgrounds.
 */
export function SidebarErrorState({
  message,
  onRetry,
  className,
  'data-testid': testId,
}: {
  message: string
  onRetry?: () => void
  className?: string
  'data-testid'?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 px-4 py-10',
        className,
      )}
      data-testid={testId}
    >
      <AlertCircle className="h-8 w-8 text-destructive" />
      <p className="text-xs text-muted-foreground text-center">{message}</p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="mr-1.5 h-3 w-3" />
          Retry
        </Button>
      ) : null}
    </div>
  )
}
